import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/delete.svg',
})
export class DeleteComponent {}
